// Checks if the build is in production based on the URL path
function isProduction() {
  return !(window.location.hostname.includes('staging') || window.location.hostname.includes('localhost'));
}

async function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export {
  isProduction,
  sleep,
}